export const IOS_APP_STORE_URL = 'https://apps.apple.com/app/id6755298805';
export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.olympiq';

/**
 * Picks the store to send a browser visitor of /app/* to. iOS → App Store;
 * Android and desktop → Play Store (per product decision 2026-05-29).
 */
export function storeUrlForUserAgent(userAgent: string): string {
  return /iPhone|iPad|iPod/i.test(userAgent)
    ? IOS_APP_STORE_URL
    : ANDROID_PLAY_STORE_URL;
}

/** Redirects the current browser to the appropriate app store. */
export function redirectToStore(): void {
  window.location.replace(storeUrlForUserAgent(navigator.userAgent));
}

export type MobilePlatform = 'ios' | 'android';

/**
 * Detects a clearly mobile platform from a user-agent string, or null when the
 * device can't be identified as iOS or Android (e.g. desktop browsers).
 */
export function mobilePlatformForUserAgent(userAgent: string): MobilePlatform | null {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';
  return null;
}

/**
 * For /app/get: when the device is clearly iOS or Android, replaces the current
 * location with the matching store and returns true. Returns false when the
 * platform can't be determined, so the caller can render manual buttons instead.
 */
export function redirectToStoreIfMobile(): boolean {
  const platform = mobilePlatformForUserAgent(navigator.userAgent);
  if (platform === 'ios') {
    window.location.replace(IOS_APP_STORE_URL);
    return true;
  }
  if (platform === 'android') {
    window.location.replace(ANDROID_PLAY_STORE_URL);
    return true;
  }
  return false;
}
